// @ts-nocheck
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from '../../../withRouter'
import { isBrowser, isTablet } from 'react-device-detect'

import { ImageSection } from './components'
import { colors } from '@lmc/common/constants'
import { history } from '../../../store'

import { isLowerThen564px } from '../../../common/utils'

const isDesktop = isBrowser || isTablet

export class ListItem extends Component {
  handleLinkClick = () => {
    history.push(this.props.to)
  }

  render() {
    const {
      children,
      inlineChildren,
      hasSubList,
      label = '',
      carePlanName,
      text,
      labelStyles,
      mainInfoContainerStyles, // allows removal of padding etc
      multiSelect, // true if there are multiple selection options e.g. DocumentItem
      onSelect,
      renderBody,
      renderRight,
      subLabel = '',
      subLabelAlert,
      style,
      to,
      subLabelChildren,
      styleHeader,
      hasBorder,
      dataTestId,
    } = this.props

    const chosenFunc = to ? this.handleLinkClick : onSelect
    const subLevelStyles = subLabelAlert
      ? styles.subLabelAlert
      : styles.subLabel

    const wrapperStyles = {
      ...styles.wrapper,
      ...style,
      ...(hasBorder && styles.wrapperBorder),
      // I commented this, because I need pointer events even when onSelect is undefined
      // change needed on edit goal
      // if this breaks anything, revert and find another way
      // pointerEvents: to || onSelect ? null : 'none',
      cursor: to || onSelect ? 'pointer' : null,
    }

    // If the list item prop hasSubList is set to true, the
    // component will render any children component in a
    // column rather than a row. See the BMI ListItem in the
    // HomeDashboard in Groups/Home for an example.
    const headerStyles = {
      display: 'flex',
      justifyContent: 'space-between',
      flexDirection: !hasSubList
        ? isDesktop || inlineChildren
          ? 'row'
          : 'column'
        : 'column',
      ...styleHeader,
    }

    return (
      <div
        className="lmc-list-item"
        data-cy={`list-item-${dataTestId}`}
        style={wrapperStyles}
        onClick={multiSelect ? null : chosenFunc}
      >
        <div
          className="lmc-list-item-header"
          data-cy={`list-item-header-${dataTestId}`}
          style={{
            ...headerStyles,
            ...(isLowerThen564px && { flexDirection: 'row' }),
          }}
        >
          <div
            className="lmc-list-item-link-container"
            data-cy={`list-link-container-${dataTestId}`}
            style={styles.leftContainer}
            onClick={multiSelect ? chosenFunc : null}
          >
            <ImageSection {...this.props} />
            <div
              className="lmc-list-item-parent-link"
              style={{
                ...styles.mainInfoContainer,
                ...mainInfoContainerStyles,
              }}
            >
              <span
                className="lmc-list-item-link"
                data-cy={`list-item-link-${dataTestId}`}
                style={{
                  ...styles.label,
                  ...labelStyles,
                }}
              >
                {label}
              </span>
              {carePlanName && (
                <span style={subLevelStyles}>Care plan: {carePlanName}</span>
              )}
              <span
                style={{
                  ...subLevelStyles,
                  ...(subLabelChildren && styles.subLabelChildren),
                }}
              >
                {subLabel} {subLabelChildren && subLabelChildren}
              </span>
              {text && <span style={styles.text}>{text}</span>}
            </div>
          </div>
          {renderRight && renderRight()}
          {children}
        </div>
        {renderBody && renderBody()}
      </div>
    )
  }
}

const styles = {
  iconContainer: {
    alignItems: 'center',
    display: 'flex',
    flexShrink: 0,
    height: 40,
    justifyContent: 'center',
    width: 40,
  },
  subLabelChildren: {
    display: 'flex',
  },
  icon: {
    color: 'white',
    height: 20,
  },
  iconText: {
    color: 'white',
    fontSize: 12,
    fontWeight: 'bold',
  },
  label: {
    fontWeight: 'bold',
    fontSize: 16,
  },
  leftContainer: {
    alignItems: 'center',
    display: 'flex',
    cursor: 'pointer',
    marginRight: 12,
    flex: 1,
  },
  mainInfoContainer: {
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: 10,
  },
  subLabel: {
    color: colors.darkgrey,
    fontSize: 14,
  },
  subLabelAlert: {
    color: colors.red,
    fontSize: 14,
  },
  text: {
    fontSize: 14,
  },
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: '8px 22px',
  },
  wrapperBorder: {
    border: '1px solid',
    borderColor: '#D9D9D9',
  },
}

ListItem.propTypes = {
  borderRadius: PropTypes.number,
  children: PropTypes.node,
  icon: PropTypes.string,
  iconColor: PropTypes.string,
  label: PropTypes.string,
  labelStyles: PropTypes.object,
  multiSelect: PropTypes.bool,
  onSelect: PropTypes.func,
  renderBody: PropTypes.func,
  renderRight: PropTypes.func,
  style: PropTypes.object,
  subLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  subLabelAlert: PropTypes.bool,
  svgIcon: PropTypes.string,
  svgIconFill: PropTypes.string,
  text: PropTypes.string,
  to: PropTypes.string,
}

export default withRouter(ListItem)
